import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function Fomo() {
  return <section className="relative isolate overflow-hidden bg-brand-900 py-24 sm:py-28" data-id="element-54" data-mp="r79qclj88mwm">
      <div aria-hidden="true" className="absolute inset-0 opacity-50 [background-image:linear-gradient(90deg,rgba(255,255,255,0.06)_1px,transparent_1px)] [background-size:64px_100%] [mask-image:radial-gradient(ellipse_at_center,black,transparent_72%)]" data-id="element-55" data-mp="ck6u0i6n4kav" />
      <div aria-hidden="true" className="absolute left-1/2 top-1/2 h-[360px] w-[860px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-500/25 blur-[120px]" data-id="element-56" data-mp="7kc005rkjell" />

      <div className="relative mx-auto max-w-3xl px-5 text-center lg:px-8" data-id="element-57" data-mp="3ps9tft3o5vkp">
        <Reveal data-id="element-58" data-mp="3upa28brwlcfi">
          <h2 className="text-[2rem] font-semibold leading-[1.1] tracking-[-0.02em] text-white sm:text-[2.9rem]" data-id="element-59" data-mp="3uquws1e7wvdd">
            El mercado no se detiene.
            <span className="mt-2 block text-brand-400" data-id="element-60" data-mp="1swlsrkoo1sra">¿Y tú?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.06} data-id="element-61" data-mp="1ufdpdo9wujs">
          <p className="mx-auto mt-7 max-w-xl text-[15.5px] leading-relaxed text-white/65" data-id="element-62" data-mp="1tckv07e4i18">
            Da el primer paso, conoce la plataforma y decide si se adapta a tu
            estrategia.
          </p>
        </Reveal>
        <Reveal delay={0.12} data-id="element-63" data-mp="6m5o1jn7nib7">
          <div className="mt-9" data-id="element-64" data-mp="6lxf22u7kx5a">
            <CTAButton label="Abrir mi cuenta" location="fomo" size="lg" className="w-full sm:w-auto" data-id="element-65" data-mp="6myz2wt7ctz5" />
            <p className="mt-5 text-[12.5px] text-white/50" data-id="element-66" data-mp="3a3xo7lbi38kh">
              Tu registro comienza online.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}